//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class AttendanceNoteTemplateUpdateItem extends ItemBase {
    Description?: string | null;
    Name?: string | null;
    BodyWithPlaceholders?: string | null;
    TeacherID?: string | null;

    constructor(initializer?: Partial<AttendanceNoteTemplateUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceNoteTemplateUpdateItem";
}
